var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCoingecko16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.167 7.05a7.083 7.083 0 1 1 -7.114-7.05 7.083 7.083 0 0 1 7.114 7.05z",
    fill: "#8dc63f",
    transform: "translate(.917 .918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.493 16.957a6.551 6.551 0 1 1 -6.581-6.518 6.552 6.552 0 0 1 6.581 6.518z",
    fill: "#f9e988",
    transform: "translate(-8.94 -8.986)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m140.341 17.635a3.6 3.6 0 0 1 1.259 0 3.837 3.837 0 0 1 1.2.4 6.987 6.987 0 0 1 1.018.745c.321.261.641.529.945.821a4.79 4.79 0 0 1 .806.975 5.558 5.558 0 0 1 .565 1.138 5.179 5.179 0 0 1 .232 2.5h-.041a11.5 11.5 0 0 0 -.616-2.341 9.108 9.108 0 0 0 -.485-1.089 10.732 10.732 0 0 0 -.637-1.027 3.712 3.712 0 0 0 -.854-.862 4.977 4.977 0 0 0 -1.085-.536c-.37-.146-.737-.3-1.123-.406s-.778-.194-1.188-.275z",
    fill: "#fff",
    transform: "translate(-132.219 -15.761)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m43.1 68.676c-.475-.138-.968-.333-1.467-.53a1 1 0 0 0 -.364-.472 1.77 1.77 0 0 0 -1.467-.15 3.663 3.663 0 0 0 -1.715-.051c-4.53 1.248-1.961 4.292-3.624 7.352a6.529 6.529 0 0 0 6.477 2.645s-1.262-3.033 1.586-4.488c2.308-1.182 3.974-3.382.574-4.306z",
    fill: "#8bc53f",
    transform: "translate(-31.773 -63.017)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m203.489 126.153a.275.275 0 1 1 -.276-.273.275.275 0 0 1 .276.273z",
    fill: "#fff",
    transform: "translate(-191.606 -118.502)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m138.48 67.991a6.774 6.774 0 0 1 1.831.622c-.256-.745-1.12-.844-1.831-.622z",
    fill: "#009345",
    transform: "translate(-130.454 -63.485)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m97.773 83.176a1.267 1.267 0 1 1 -1.267-1.266 1.267 1.267 0 0 1 1.267 1.266z",
    fill: "#fff",
    transform: "translate(-89.434 -76.789)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m104.342 90.331a.891.891 0 1 1 -.891-.891.891.891 0 0 1 .891.891z",
    fill: "#58595b",
    transform: "translate(-96.378 -83.932)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m43.3 131.787a6.335 6.335 0 0 1 -3.849 1.272c-.775 0-.932-.821-1.444-.42a3.646 3.646 0 0 1 -1.936.639 2.41 2.41 0 0 1 -2.271-2.048 11.552 11.552 0 0 1 -.8 4.07 6.407 6.407 0 0 0 6.55 2.72c-.273-1.917 1.405-3.795 2.347-4.754a12.422 12.422 0 0 0 1.4-1.484z",
    fill: "#8bc53f",
    transform: "translate(-30.388 -123.577)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m144.386 142.706a4.593 4.593 0 0 1 -1.084.7 6.925 6.925 0 0 1 -1.216.443 3.821 3.821 0 0 1 -1.3.15 1.777 1.777 0 0 1 -1.188-.522l.014-.016a2.263 2.263 0 0 0 1.187.327 5.558 5.558 0 0 0 1.247-.1 6.812 6.812 0 0 0 1.212-.375 4.509 4.509 0 0 0 1.113-.616z",
    fill: "#58595b",
    transform: "translate(-131.517 -134.449)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoingecko16);
export default __webpack_public_path__ + "static/media/ic_coingecko_16.ef20d202d0df8c5e90a98a2626688574.svg";
export { ForwardRef as ReactComponent };